import { render, staticRenderFns } from "./RegisterForTeam.vue?vue&type=template&id=9f8fdf48&"
import script from "./RegisterForTeam.vue?vue&type=script&lang=js&"
export * from "./RegisterForTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports